import React from 'react'
import { useNavigate } from 'react-router-dom';

import classes from './../Onboarding.module.scss';
import UpperDiv from './UpperDiv';
import LowerDiv from './LowerDiv';
import problem_1 from './../../../assets/onboarding/problem_1.svg'
import problem_2 from './../../../assets/onboarding/problem_2.svg'
import Pagination from './Pagination';

const upperDivStyle = {
  display: "flex",
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: 0
}

const lowerDivStyle = {
  display: "flex",
  flexDirection: 'column',
  gap: '0'
}

const problem_1_style = {
  maxWidth: '85%',
}

const problem_2_style = {
  maxWidth: '35%',
}

const Page6 = () => {
  const navigate = useNavigate();

  return (
    <>
      <UpperDiv style={upperDivStyle}>
        <img src={problem_1} alt="" style={problem_1_style} />

      </UpperDiv>
      <LowerDiv style={lowerDivStyle}>
        <div className={classes.Page2Div}>
          <img src={problem_2} alt="" style={problem_2_style} />
          <h3 className={classes.Page2H3}>
            If There Is Any Problem
          </h3>
          <p className={classes.NameH3}>
          In case of any problem kindly click on the help button.
          </p>
        </div>
        <div className={classes.Page2Pagination}>
        <div style={{ display: 'flex' , width:"100%"}}>
            <button onClick={() => { navigate('/onboarding/5') }}>
              PREV
            </button>
            <button onClick={() => { navigate('/onboarding/7') }}>
              NEXT
            </button>
          </div>
          <Pagination numberOfDots={7} activePage={6} />
        </div>
      </LowerDiv>
    </>
  )
}

export default Page6